import React, { useEffect, useMemo } from "react";
import Router from "./routes/Router";
import { useDispatch, useSelector } from "react-redux";
import { userDetails } from "./store/actions/user";
import { resetModal } from "./store/actions/modalToggle";
import { userLocale } from "./store/actions/locale";
import { ENGLISH_LOCALE, ROMANIAN_LOCALE } from "./languages";
import { isAuthenticated } from "./api/helper";

function getUserProfile(state) {
  return {
    id: state?.user?.profile?.id,
  };
}

function getLang(state) {
  return {
    lang: state?.locale?.lang,
  };
}

function useBodyLanguage() {
  const dispatch = useDispatch();
  const { lang } = useSelector(getLang);

  useEffect(() => {
    const rootEl = document.getElementById("root");
    if (rootEl) {
      rootEl.classList.add(`lang-${lang}`);
    }

    switch (lang) {
      case ENGLISH_LOCALE.lang:
        dispatch(userLocale(ENGLISH_LOCALE));
        break;
      default:
        dispatch(userLocale(ROMANIAN_LOCALE));
        break;
    }

    return () => {
      if (rootEl) {
        rootEl.classList.remove(`lang-${lang}`);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);
}

function useAuthenticated() {
  const dispatch = useDispatch();
  const profile = useSelector(getUserProfile);
  const isUserAuthenticated = useMemo(() => isAuthenticated(), [profile.id]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isUserAuthenticated) {
      dispatch(userDetails(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthenticated]);

  useEffect(() => {
    dispatch(resetModal());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

function AppComponent() {
  useBodyLanguage();
  useAuthenticated();

  return <Router />;
}

export { AppComponent as App };
